/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMBannerViewEvent } from '@/data/events/handlers/gtm/BannerView';
import { GTMBannerViewPayload } from '@/data/types/GTM';

type ProductViewDelegatorProps = {
	gtm?: GTMBannerViewPayload;
};

export const bannerViewDelegator = async (payload: ProductViewDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMBannerViewEvent(gtm);
	}
};
